module.exports = __webpack_public_path__ + "static/media/mob-pain-winner-bg.9a5a53d2.png";